import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './createUserTasteComparisonMutation.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type CreateUserTasteComparisonMutation_createUserTasteComparison_UserTasteComparison_learnedTrait_UserTasteTrait = {
  __typename: 'UserTasteTrait',
  feature: string,
  isConfident: boolean,
  level: Types.UserTasteTraitLevel
};

export type CreateUserTasteComparisonMutation_createUserTasteComparison_UserTasteComparison = {
  __typename: 'UserTasteComparison',
  id?: number | null,
  outcome?: Types.UserTasteComparisonOutcome | null,
  roundPickNumber: number,
  learnedTrait?: CreateUserTasteComparisonMutation_createUserTasteComparison_UserTasteComparison_learnedTrait_UserTasteTrait | null
};

export type CreateUserTasteComparisonMutation_Mutation = {
  __typename?: 'Mutation',
  createUserTasteComparison: CreateUserTasteComparisonMutation_createUserTasteComparison_UserTasteComparison
};


export type CreateUserTasteComparisonMutationVariables = Types.Exact<{
  leftMenuItemId: Types.Scalars['Int']['input'];
  rightMenuItemId: Types.Scalars['Int']['input'];
  outcome: Types.UserTasteComparisonOutcome;
}>;


export type CreateUserTasteComparisonMutation = CreateUserTasteComparisonMutation_Mutation;


export const CreateUserTasteComparisonDocument = /*#__PURE__*/ document as unknown as DocumentNode<CreateUserTasteComparisonMutation, CreateUserTasteComparisonMutationVariables>;

export type CreateUserTasteComparisonMutationFn = ApolloReactCommon.MutationFunction<CreateUserTasteComparisonMutation, CreateUserTasteComparisonMutationVariables>;

/**
 * __useCreateUserTasteComparisonMutation__
 *
 * To run a mutation, you first call `useCreateUserTasteComparisonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserTasteComparisonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserTasteComparisonMutation, { data, loading, error }] = useCreateUserTasteComparisonMutation({
 *   variables: {
 *      leftMenuItemId: // value for 'leftMenuItemId'
 *      rightMenuItemId: // value for 'rightMenuItemId'
 *      outcome: // value for 'outcome'
 *   },
 * });
 */
export function useCreateUserTasteComparisonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserTasteComparisonMutation, CreateUserTasteComparisonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserTasteComparisonMutation, CreateUserTasteComparisonMutationVariables>(CreateUserTasteComparisonDocument, options);
      }
export type CreateUserTasteComparisonMutationHookResult = ReturnType<typeof useCreateUserTasteComparisonMutation>;
export type CreateUserTasteComparisonMutationResult = ApolloReactCommon.MutationResult<CreateUserTasteComparisonMutation>;
export type CreateUserTasteComparisonMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserTasteComparisonMutation, CreateUserTasteComparisonMutationVariables>;